import { StyleSheet } from 'react-native';

import { widthPercentageToDP } from 'utils/responsiveness';

const styles = StyleSheet.create({
    title: {
        marginLeft: widthPercentageToDP(16, 44, 72),
    },
});

export default styles;
